var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ [_vm.$style.step]: true, [_vm.$style.stepActive]: _vm.step.isActive, [_vm.$style.stepDisabled]: _vm.step.isDisabled }},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.clickHandler.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.step.id))]),_c('p',[_vm._v(_vm._s(_vm.step.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }